import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';


@Component({
  selector: 'app-bet-selection',
  templateUrl: './bet-selection.component.html',
  styleUrls: ['./bet-selection.component.scss'],
})
export class BetSelectionComponent implements OnInit {
  @Input() item: any;

  constructor(public modalController: ModalController) { }

  ngOnInit() {
    //console.log(this.item)
  }

  dismiss() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }


}
